<template>
  <div class="live-footer">
    <footer class="footer">
      <!-- 二维码 -->
      <div class="footer-qrimg" v-if="qrCodes.length">
        <div class="qr-img-item" v-for="(qr, idx) in qrCodes" :key="`qr_${idx}`">
          <img :src="qr.links" class="qr-img" />
          <p>{{ qr.title }}</p>
        </div>
      </div>

      <!-- 协议链接 -->
      <div class="footer-links" v-if="links.length">
        <span v-for="(item, idx) in links" :key="`link_${idx}`">
          <a :href="item.links" target="_blank">{{ item.title }}</a>
          <span class="split" v-if="idx != links.length-1">|</span>
        </span>
      </div>

      <div class="footer-text">
        <span>四川华晟联采供应链管理有限公司</span>
        <span>版权所有</span>
        <span>@www.likehuanxin.com | 400-8888-8794</span>
        <span
          >为了防范电信网络诈骗，如网民接到焕新生活官网电话，请立即接听。</span
        >
      </div>
      <div class="footer-text">
        <span
          ><a href="https://beian.miit.gov.cn/" target="_blank"
            >蜀ICP备2023017988号-1</a
          ></span
        >
        <!-- <span>广播电视节目制作经营许可证（沪）字第03283号 网络文化经营许可证 沪网文{2022}1460-055号</span> -->
      </div>
    </footer>
  </div>
</template>

<script>
import {
  getIndexBannerListApi // 获取首页顶部推荐视频以及二维码列表
} from "@/api/apis/liveHome.js";
export default {
  name: "LiveFooter",
  data() {
    return {
        qrCodes:[],
        links: [
          //{title: '1111', url: 'http://127.0.0.1:8888/#/agreement?type=userAboutAgreement'},
          //{title: '2222', url: 'http://127.0.0.1:8888/#/agreement?type=userAboutAgreement'}
        ]
    };
  },
  computed: {},
  mounted() {
    this.getIndexBannerList();
  },
  methods: {
    //获取轮播图
    getIndexBannerList() {
      getIndexBannerListApi().then(res => {
        this.qrCodes = res.data.qrCodes || [];
        this.links = res.data.protocolList || [];
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.footer-links{
  text-align: center;
  .split{
    padding:0 5px 0 3px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/live/LiveFooter.vue